/** Display-only F1 helpers for the public Stats feed. Never includes user names. */

const COUNTRY_FLAG: Record<string, string> = {
  australia: '🇦🇺',
  china: '🇨🇳',
  japan: '🇯🇵',
  bahrain: '🇧🇭',
  'saudi arabia': '🇸🇦',
  usa: '🇺🇸',
  'united states': '🇺🇸',
  canada: '🇨🇦',
  monaco: '🇲🇨',
  spain: '🇪🇸',
  austria: '🇦🇹',
  'great britain': '🇬🇧',
  uk: '🇬🇧',
  belgium: '🇧🇪',
  hungary: '🇭🇺',
  netherlands: '🇳🇱',
  italy: '🇮🇹',
  azerbaijan: '🇦🇿',
  singapore: '🇸🇬',
  mexico: '🇲🇽',
  brazil: '🇧🇷',
  qatar: '🇶🇦',
  'abu dhabi': '🇦🇪',
  uae: '🇦🇪',
}

const TEAM_COLOR: Record<string, string> = {
  mercedes: '#00D2BE',
  ferrari: '#E10600',
  mclaren: '#FF8000',
  'red bull': '#3671C6',
  'aston martin': '#229971',
  alpine: '#0093CC',
  williams: '#1868DB',
  haas: '#9EA0A3',
  audi: '#F50537',
  cadillac: '#D4AF37',
  'racing bulls': '#6B93FF',
}

export const F1_MEDAL = ['🥇', '🥈', '🥉'] as const

export function f1CountryFlag(country?: string | null): string {
  if (!country) return '🏎️'
  const key = country.trim().toLowerCase()
  return COUNTRY_FLAG[key] || '🏎️'
}

export function f1TeamColor(team?: string | null): string {
  if (!team) return '#38bdf8'
  const key = team.trim().toLowerCase()
  const hit = Object.keys(TEAM_COLOR).find((k) => key.includes(k) || k.includes(key))
  return hit ? TEAM_COLOR[hit] : '#38bdf8'
}

export function f1DriverShort(name: string): string {
  const parts = name.trim().split(/\s+/)
  return parts[parts.length - 1] || name
}
